import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block-content" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "surface-section px-4 py-8 md:px-6 lg:px-8" }
const _hoisted_4 = { class: "flex flex-column lg:flex-row justify-content-center align-items-center gap-7" }
const _hoisted_5 = ["src"]

import { useRouter } from 'vue-router';
import pageNotFoundImg from '@/assets/Images/404.jpg'


export default /*@__PURE__*/_defineComponent({
  __name: '404',
  setup(__props) {

const router = useRouter();

function navigateHome() {
    router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", { class: "text-center lg:text-right" }, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mt-6 mb-3 font-bold text-6xl text-900" }, "Are you lost?", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-700 text-3xl mt-0 mb-6" }, "Sorry, we couldn't find the page.", -1)),
            _createElementVNode("button", {
              class: "p-button p-component p-button-outlined",
              type: "button",
              "aria-label": "Go back to home page",
              onClick: navigateHome
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "p-button-label" }, "Go back to home page", -1),
              _createElementVNode("span", {
                class: "p-ink",
                role: "presentation"
              }, null, -1)
            ]))
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("img", {
              src: _unref(pageNotFoundImg),
              alt: "Image",
              class: "w-full md:w-28rem"
            }, null, 8, _hoisted_5)
          ])
        ])
      ])
    ])
  ]))
}
}

})